import { inject, Injectable } from '@angular/core';
import { lastValueFrom } from 'rxjs';
import { getLatestTaskScorePath } from '../../../shared/misc-utilities/sampling-portal-paths';
import { QaFeedback, Task } from '../../../team-apis/otterdam/task';
import { TaskWorkspaceStore } from '../../h3ml/state/task-workspace-store';
import { AbstractResource } from '../abstract-resource';

@Injectable()
export class LastRoundFeedbackLoadingService extends AbstractResource {
  private store = inject(TaskWorkspaceStore);

  async load(task: Task) {
    const { projectId } = this.workspaceConfig;
    if (task.round > 1) {
      const lastRound = task.round - 1;
      const path = getLatestTaskScorePath(projectId, task.id, lastRound);
      const latestTaskScore = await lastValueFrom(
        this.request$<QaFeedback>('GET', path, {
          tokenScope: 'access_token',
          customErrorMessage: 'Failed to load last round feedback.',
        }),
      );
      this.store('lastRoundQaFeedbacks').set([latestTaskScore]);
    } else {
      this.store('lastRoundQaFeedbacks').set([]);
    }
  }
}
